<template>
  <div class="wombat-row-default-cell role">
    {{ item[column.field] }}
  </div>
</template>

<script>
export default {
  name: 'WombatRowDefaultCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.role {
  text-transform: capitalize;
}
</style>
